























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
    TextLine: require('./TextLine').default
  }
})
export default class TextLines extends Vue {
  @Prop()
  value: string[][]

  lines: string[][] = this.value

  add() {
    this.lines.push([])
  }

  remove(i: number) {
    this.lines.splice(i, 1)
  }

  @Watch('lines')
  watchLines() {
    this.$emit('input', this.lines)
  }
}
